// styles
import { workingHoursStyles, fragmentedTimeStyles } from "../renderers";

export const styles = {
  ...workingHoursStyles,
  ...fragmentedTimeStyles,
};
